import React from 'react';
import { Section } from '@atlaskit/menu';
import { UFOThirdPartySegment as PlatformUFOThirdPartySegment } from '@atlaskit/react-ufo/segment';
import { UFOThirdPartySegment as JiraUFOThirdPartySegment } from '@atlassian/jira-ufo-segment/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { BoardConnectMenuItems } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsCMPBoard, useIsJSMBoard } from '../../../../state/state-hooks/capabilities/index.tsx';
import Operations from '../../extension/index.tsx';

type BoardConnectItemsProps = {
	projectKey: string;
	boardId: string;
	onClickWebItem?: () => void;
	isTabNavigation?: boolean;
};

const UFOThirdPartySegment = componentWithFG(
	'issue_add_third_party_ufo_segments',
	JiraUFOThirdPartySegment,
	PlatformUFOThirdPartySegment,
);

const UFOSegmentWrapper = ({
	children,
	name,
}: React.ComponentProps<typeof UFOThirdPartySegment>) =>
	fg('fix_blindspots_for_board_and_backlog') ? (
		<UFOThirdPartySegment name={name}>{children}</UFOThirdPartySegment>
	) : (
		<>{children}</>
	);

export const BoardConnectItems = ({
	projectKey,
	boardId,
	onClickWebItem,
	isTabNavigation = false,
}: BoardConnectItemsProps) => {
	const isCMPBoard = useIsCMPBoard();
	const isJSMBoard = useIsJSMBoard();

	return (
		<UFOSegmentWrapper name="board-header-connect-items">
			<Section hasSeparator={!isJSMBoard}>
				{isCMPBoard && (
					<>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="board-tools-1"
							onClickWebItem={onClickWebItem}
							mode="work"
							isTabNavigation={isTabNavigation}
						/>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="view-actions-work"
							onClickWebItem={onClickWebItem}
							mode="work"
							isTabNavigation={isTabNavigation}
						/>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="view-actions-print"
							onClickWebItem={onClickWebItem}
							mode="work"
							isTabNavigation={isTabNavigation}
						/>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							mode="work"
							onClickWebItem={onClickWebItem}
							isTabNavigation={isTabNavigation}
						/>
					</>
				)}
				<Operations isTabNavigation={isTabNavigation} />
			</Section>
		</UFOSegmentWrapper>
	);
};
